export default {
    copiedBroadcastId: 0,
    copyingBroadcast: false,
    lastBroadcastSource: '',
    newestBroadcastId: 0,
};
